import { combineReducers } from 'redux';
import accountManagement from './accountManagementReducer';

export default combineReducers({
  accountManagement,
});
